export default __webpack_public_path__ + "static/media/Rectangle 1682.beea6dbb.png";